import inscriptionListStore from '@modules/inscription/inscription-list-store';
import inscriptionViewStore from '@modules/inscription/inscription-view-store';
import inscriptionImporterStore from '@modules/inscription/inscription-importer-store';
import inscriptionFormStore from '@modules/inscription/inscription-form-store';
import inscriptionDestroyStore from '@modules/inscription/inscription-destroy-store';

export default {
    namespaced: true,

    modules: {
        destroy: inscriptionDestroyStore,
        form: inscriptionFormStore,
        list: inscriptionListStore,
        view: inscriptionViewStore,
        importer: inscriptionImporterStore,
    },
};